import PageCard  from '../../components/proSafety/PageCard/PageCard';
import styles from './Principles.module.css';
export default function PrinciplesPage() {
    return (
        <div className={styles.pageTitle}>
            <h1>Основные принципы защитного вождения</h1>
            <PageCard title="1. Предвидение">
                <p>Постоянно сканируйте дорогу вперёд. Предугадывайте действия других участников.</p>
            </PageCard>
            <PageCard title="2. Безопасная дистанция">
                <p>Соблюдайте правило 3-х секунд до впереди идущего автомобиля. В плохую погоду увеличивайте
                    дистанцию.</p>
            </PageCard>
            <PageCard title="3. Управление пространством">
                <p>Оставляйте свободное пространство вокруг автомобиля для манёвра в экстренной ситуации.</p>
            </PageCard>
            {/* ... ещё карточки */}
        </div>
    );
}